<div
	[formGroup]="form"
	gdColumns="repeat(auto-fill, minmax(250px, 1fr))"
	gdGap="10px"
>
	<mat-form-field>
		<input
			matInput
			formControlName="searchText"
			placeholder="Search"
			autocomplete="off"
		/>
		<mat-icon matSuffix>search</mat-icon>
	</mat-form-field>

	<rpshared-customer-id formControlName="customerId"></rpshared-customer-id>
</div>
